export const CLEAR_APP = "CLEAR_APP";

// Types
export const CLEAR_USER = "CLEAR_USER";
export const VALUE_STATE = "VALUE_STATE";
export const UPDATE_ARRAY = "UPDATE_ARRAY";

export const REVIEWED_WORDS = "REVIEWED_WORDS";

export const REVIEWED_WORDS_INDIRECTORY = "REVIEWED_WORDS_INDIRECTORY";
export const TYPE_WORLD = "TYPE_WORLD";
export const BOOLEAN_VOICE = "BOOLEAN_VOICE";
export const ARRAY_FOR_NEWWOLRD_FOOTER = "ARRAY_FOR_NEWWOLRD_FOOTER";
export const ARAY_NEW_WORLD_TYPE_BLAK = "ARAY_NEW_WORLD_TYPE_BLAK";
export const SPEAKING_PICTURE = "SPEAKING_PICTURE";
export const SPEAKING_WORD = "SPEAKING_WORD";
export const SET_COORECT_ANSWER = "SET_CORRECT_ANSWER";
export const QUESTION_TYPE = "QUESTION_TYPE";
export const LANGUAGE_TYPE = "LANGUAGE_TYPE";
export const WOERD_IN_ANSWER = "WOERD_IN_ANSWER";
export const FLASHCARD_CORRECTANSWER = "FLASHCARD_CORRECTANSWER";
export const FLASHCARD_TITLE = "FLASHCARD_TITLE";
export const WORDS_MAIN = "WORDS_MAIN";
export const TITLE = "TITLE";
export const CORECTANWERNEW = "CORECTANWERNEW";
export const DATA_LOCATION = "DATA_LOCATION";
export const VOICE = "VOICE";
export const CORRECT_ANSWER = "CORRECT_ANSWER";
export const ANSWER = "ANSWER";
export const WORDS = "WORDS";
export const VALIDATION = "VALIDATION";
export const ANSWER_ALL_TYPE = "ANSWER_ALL_TYPE";
export const VOIC_FILE_LISTENING = "VOIC_FILE_LISTENING";
export const QUESTIONS = "QUESTIONS";
export const MATCHINGWORD = "MATCHINGWORD";
export const SETLANGMAIN = "SETLANGMAIN";
export const CHECKPOINT_SKILL_ID = "CHECKPOINT_SKILL_ID";
export const LEVEL_LESSON_ID = "LEVEL_LESSON_ID";
export const RESET_STORE = "RESET_STORE";
export const TYPE_FOR_NEW_ARRAY = "TYPE_FOR_NEW_ARRAY";
export const NEW_ARRAY_FOOTER_UI = "NEW_ARRAY_FOOTER_UI";
export const WORDLIST = "WORDLIST";
export const CHANGE_LANG_T_WB = "CHANGE_LANG_T_WB";
export const TYPE_QUESTION_MAIN = "TYPE_QUESTION_MAIN,";
export const CLEAR_QUESTION = "CLEAR_QUESTION";
export const BOOLEAN_VOICE_LISTENING = "BOOLEAN_VOICE_LISTENING";

//////////////////////////////////////////// editreducer
export const EDIT = "EDIT";
export const CLEAR_EDIT = "CLEAR_EDIT" 
export const EDIT_TITLE = "EDIT_TITLE";
export const EDIT_TYPE = "EDIT_TYPE";
export const EDIT_AUDIO = "EDIT_AUDIO";
export const EDIT_VOICE = "EDIT_VOICE";
export const EDIT_PICTURE = "EDIT_PICTURE";
export const EDIT_VOICE_TYPE = "EDIT_VOICE_TYPE";
export const EDIT_LANGUAGE = "EDIT_LANGUAGE";
export const EDIT_REVIEWED_WORDS = "EDIT_REVIEWED_WORDS";
export const EDIT_REVIEWED_INDIRECTLY = "EDIT_REVIEWED_INDIRECTLY";
export const EDIT_WORDS = "EDIT_WORDS";
export const EDIT_ANSWER = "EDIT_ANSWER";
export const EDIT_WORD = "EDIT_WORD";
export const EDIT_OPTION = "EDIT_OPTION";
export const EDIT_CORRECT_ANSWER = "EDIT_CORRECT_ANSWER";
export const EDIT_ID = "EDIT_ID";
export const EDIT_NEW_WORDS = "EDIT_NEW_WORDS"; 